import { Component, ViewChild, computed, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenav } from '@angular/material/sidenav';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { AuthService, isTokenExpired } from './auth/services/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule,
    SidebarComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  @ViewChild('sidenav') sidenav!: MatSidenav;
  title = 'TMS';

  private authService = inject(AuthService);
  private router = inject(Router);

  public readonly isLoggedIn = computed(() => {
    const loggedIn = this.authService.isLoggedIn();
    const token = this.authService.getToken();
    const tokenExpired = token ? isTokenExpired(token) : true;
    return loggedIn && !tokenExpired;
  });

  public readonly isTokenExpired = computed(() => {
    const token = this.authService.getToken();
    return token ? isTokenExpired(token) : true;
  });

  ngOnInit() {
    // Subscribe to router events to handle authentication state
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      // Check authentication on each navigation
      if (!this.isLoggedIn()) {
        this.router.navigate(['/login']);
      }
    });
  }
}
